var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.menu),function(category){return [_vm._t(("parent_" + (category.id)),null,{"category":category,"children":category.children})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }